import React, { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Icon from './Icon';

function ClickableDropdown(
    { onClick, isOpen, className, options, buttonName, buttonClass = 'sg-button-primary' },
    ref
) {
    const toggleDropdown = (event) => {
        event.stopPropagation();
        onClick();
    };

    return (
        <div className={cn('clickable-dropdown', className, isOpen && 'clickable-dropdown--active')} ref={ref}>
            <div className={cn(buttonClass, 'clickable-dropdown__button')} onClick={toggleDropdown}>
                {buttonName}
                <div className="clickable-dropdown__button__arrow-container">
                    <Icon alias="caret-down" />
                </div>
            </div>
            <div className="clickable-dropdown__options">
                <div className="clickable-dropdown__options__inner-wrapper">
                    {options.map((option, index) => (
                        <div
                            className={cn('clickable-dropdown__options__option', option.disabled && 'disabled')}
                            /* eslint-disable-next-line react/no-array-index-key */
                            key={index}
                            title={option.title}
                            onClick={(e) => {
                                if (option.disabled) {
                                    return;
                                }
                                option.onClick(e);
                                toggleDropdown(e);
                            }}
                        >
                            {option.title}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default forwardRef(ClickableDropdown);

ClickableDropdown.propTypes = {
    className: PropTypes.string,
    buttonClass: PropTypes.string,
    buttonName: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        })
    ).isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
